import * as React from "react";

const SvgSortIdle = props => <svg id="import_export-24px" xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}><path id="Path_8358" data-name="Path 8358" d="M0,0H12V16H0Z" fill="none" /><path id="Path_8359" data-name="Path 8359" d="M7,3,5,5.66H6.5v4.673h1V5.66H9Zm3.5,9.34V7.667h-1V12.34H8L10,15l2-2.66Z" transform="translate(-2.5 -1)" fill="#fff" /></svg>;

export default SvgSortIdle;